import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  timeout: 30000,
});

export const fetchVideos = async ({ q, category, sort, playlist, limit = 60, skip = 0 } = {}) => {
  const params = {};
  if (q) params.q = q;
  if (category && category !== "All") params.category = category;
  if (sort) params.sort = sort;
  if (playlist) params.playlist = playlist;
  params.limit = limit;
  params.skip = skip;
  const res = await api.get("/videos", { params });
  return res.data;
};

export const fetchCategories = async () => {
  const res = await api.get("/videos/categories");
  return res.data;
};

export const fetchChannel = async () => {
  const res = await api.get("/channel");
  return res.data;
};

export const fetchVideo = async (id) => {
  const res = await api.get(`/videos/${id}`);
  return res.data;
};

export const fetchGameNav = async (game, level) => {
  const res = await api.get(`/levels/${game}/nav/${level}`);
  return res.data;
};

export const fetchGameSummary = async (game) => {
  const res = await api.get(`/levels/${game}/summary`);
  return res.data;
};

export const fetchGameRange = async (game, start, end) => {
  const res = await api.get(`/levels/${game}/range`, { params: { start, end } });
  return res.data;
};


export const listSupporters = async () => {
  const res = await api.get("/supporters");
  return res.data;
};

export const addSupporter = async (name) => {
  const res = await api.post("/supporters", { name });
  return res.data;
};


export const findGameLevel = async (game, level) => {
  const res = await api.get(`/levels/${game}/level/${level}`);
  return res.data;
};


export const listCollections = async (q) => {
  const res = await api.get("/collections", { params: q ? { q } : {} });
  return res.data;
};

export const getCollection = async (slug) => {
  const res = await api.get(`/collections/${slug}`);
  return res.data;
};

export const createCollection = async ({ title, description, video_ids = [] }) => {
  const res = await api.post("/collections", { title, description, video_ids });
  return res.data;
};

export const addVideosToCollection = async (slug, video_ids) => {
  const res = await api.post(`/collections/${slug}/videos`, { video_ids });
  return res.data;
};

export const removeVideoFromCollection = async (slug, video_id) => {
  const res = await api.delete(`/collections/${slug}/videos/${video_id}`);
  return res.data;
};

export const deleteCollection = async (slug) => {
  const res = await api.delete(`/collections/${slug}`);
  return res.data;
};

export const updateCollection = async (slug, patch) => {
  const res = await api.patch(`/collections/${slug}`, patch);
  return res.data;
};

export const startPlaylistImport = async () => {
  const res = await api.post("/youtube/import-playlists", {});
  return res.data;
};

export const getPlaylistImportStatus = async () => {
  const res = await api.get("/youtube/import-playlists/status");
  return res.data;
};

export const formatNumber = (n) => {
  if (n == null) return "0";
  if (n >= 1_000_000) return (n / 1_000_000).toFixed(1).replace(/\.0$/, "") + "M";
  if (n >= 1_000) return (n / 1_000).toFixed(1).replace(/\.0$/, "") + "K";
  return String(n);
};

export const formatDuration = (seconds) => {
  if (!seconds || seconds < 0) return "0:00";
  const h = Math.floor(seconds / 3600);
  const m = Math.floor((seconds % 3600) / 60);
  const s = seconds % 60;
  if (h > 0) return `${h}:${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")}`;
  return `${m}:${String(s).padStart(2, "0")}`;
};

export const formatDate = (iso) => {
  if (!iso) return "";
  try {
    return new Date(iso).toLocaleDateString(undefined, {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  } catch {
    return iso;
  }
};
